import getAxiosInstance from "../../common/mhiAxios";

export default {
    //統計情報取得
    getStatistics(startDate: String, endDate: String): Promise<any> {
        return getAxiosInstance()
            .get("/api/getStatistics", { params: { startDate: startDate, endDate: endDate } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //ランキング情報取得
    getPoputlarRanking(startDate: String, endDate: String): Promise<any> {
        return getAxiosInstance()
            .get("/api/getPopularRanking", { params: { startDate: startDate, endDate: endDate } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //統計情報取得
    getDocumentStatistics(startDate: String, endDate: String): Promise<any> {
        return getAxiosInstance()
            .get("/api/getDocumentStatistics", {
                params: { startDate: startDate, endDate: endDate },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //ランキング情報取得
    getDocumentPoputlarRanking(startDate: String, endDate: String): Promise<any> {
        return getAxiosInstance()
            .get("/api/getDocumentPopularRanking", {
                params: { startDate: startDate, endDate: endDate },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 統計情報の登録(ドキュメント）
    saveDocumentStatistics(
        userId: number,
        documentId: number,
        documentTag: String,
        documentTitle: String,
        imageUrl: String
    ) {
        return getAxiosInstance()
            .post("/api/saveDocumentStatistics", {
                userId: userId,
                documentId: documentId,
                documentTag: documentTag,
                documentTitle: documentTitle,
                imageUrl: imageUrl,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
